<div class="main">
    <div class="dashboard-header">
      <img [src]="getImageUrl()" alt="Logo" style="width: 150px;margin:6px;">
    </div>
    <div class="navbar" style="justify-content: space-between;">
      <div class="nav-item" style="font-size: 13px;">
        <a (click)="customer()"> Customer Profile </a>
        <!-- <div *ngIf="showContentConfiguration" >
          <a (click)="openGeneres()"></a>
      </div> -->
      </div>
      <div class="user-info" style="margin-right: 11px;">
        <!-- <span>Welcome : User</span><i class="fas fa-user" (click)="openprofilePopup();"></i> -->
        <div class="nav-item" style="font-size: 15px;">
          <span style="color: black;">Welcome : {{userName ? userName : 'User'}}</span><a><i class="fas fa-user"></i></a>
          <div class="dropdown">
            <a style="white-space: nowrap;" (click)="openAddForm(addChangePasswordModal);this.showConfirmPassword = false;
              this.showNewPassword = false;
            "> Change Password</a>
            <a (click)="openAddForm(openLogOutModel)"> Logout</a>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="Generes">
        <span style="position: relative; bottom: -7em; left: 1em; font-size: 12px;">
            <i class="fas fa-home"></i> / 
            <span 
                (click)="customer()"
                style="cursor: pointer; transition: color 0.3s;"
                onmouseover="this.style.color='#007bff'"
                onmouseout="this.style.color='inherit'">
                Customer Profile
            </span> 
            / Set Ringtone / View
        </span>
        <div class="container-fluid">
            <div class="row">
                <div
                class="col-md-7"
                style="border: 1px solid #ccc; padding-left: 15px; padding-top: 15px; width: 72%; border-radius: 8px; padding-right: 15px;"
              >
                <h5 class="mb-3">Select Ringtone</h5>
                <div class="row mb-3">
                  <div class="col-md-9">
                    <label for="rowsPerPage" class="form-label me-2">Rows per page:</label>
                    <select
                      id="rowsPerPage"
                      class="form-select d-inline-block w-auto"
                      [(ngModel)]="rowsPerPage"
                      (change)="updatePagination()"
                    >
                      <option *ngFor="let size of [5, 10, 15]" [value]="size">
                        {{ size }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-3 text-end">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search"
                      [(ngModel)]="searchQuery"
                      (ngModelChange)="filterTransactions()"
                    />
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr style="text-align: center;">
                        <th (click)="sortTransactions('id')" style="cursor: pointer">
                          S.No
                          <span *ngIf="sortField === 'id'">
                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                          </span>
                        </th>
                        <th>Select Music</th>
                        <th (click)="sortTransactions('promoCode')" style="cursor: pointer">
                          Promo Code
                          <span *ngIf="sortField === 'promoCode'">
                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                          </span>
                        </th>
                         <th (click)="sortTransactions('toneCode')" style="cursor: pointer">
                          Tone Code
                          <span *ngIf="sortField === 'toneCode'">
                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                          </span>
                        </th>
                        <th (click)="sortTransactions('songName')" style="cursor: pointer">
                          Song Name
                          <span *ngIf="sortField === 'songName'">
                            {{ sortDirection === 'asc' ? '↑' : '↓' }}
                          </span>
                        </th>
                        <th (click)="sortTransactions('artists')" style="cursor: pointer">Artist <span *ngIf="sortField === 'artists'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="filteredTransactions.length === 0">
                        <td colspan="5" class="text-center text-danger">No matching records found</td>
                      </tr>
                      <tr *ngFor="let transaction of paginatedTransactions; let i = index" style="text-align: center;">
                        <td>{{ (currentPage - 1) * rowsPerPage + i + 1 }}</td>
                        <td>
                          <input
                            type="checkbox"
                            [checked]="selectedTransaction === transaction"
                            (change)="onCheckboxChange(transaction)"
                          />
                        </td>
                        <td>{{ transaction.promoCode }}</td>
                        <td>{{ transaction.toneCode }}</td>
                        <td>{{ transaction.songName }}</td>
                        <td>{{ transaction.artists }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- <nav *ngIf="filteredTransactions.length > rowsPerPage" style="margin-top: 10px;">
                  <div class="d-flex justify-content-between align-items-center w-100">
                    <span>
                      Showing {{ getStartIndex() }} to {{ getEndIndex() }} of {{ filteredTransactions.length }} entries
                    </span>
                    <div>
                      <button
                        class="btn btn-secondary me-2"
                        [disabled]="currentPage === 1 || filteredTransactions.length === 0"
                        (click)="changePage(currentPage - 1)"
                      >
                        Prev
                      </button>
                      <ng-container *ngFor="let page of getPages()">
                        <button
                          *ngIf="!isValidPage(page)"
                          class="btn1 btn-secondary me-2"
                          disabled
                        >
                          {{ page }}
                        </button>
                        <button
                          *ngIf="isValidPage(page)"
                          class="btn1 btn-secondary me-2"
                          [class.active]="page === currentPage"
                          (click)="changePage(page)"
                        >
                          {{ page }}
                        </button>
                      </ng-container>
                      <button
                        class="btn btn-secondary"
                        [disabled]="currentPage === totalPages || filteredTransactions.length === 0"
                        (click)="changePage(currentPage + 1)"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </nav> -->
                
                <nav *ngIf="filteredTransactions.length > rowsPerPage" style="margin-top: 10px;">
                  <div class="pagination-controls">
                    <!-- Pagination Info -->
                    <span>
                      Showing {{ getStartIndex() }} to {{ getEndIndex() }} of {{ filteredTransactions.length }} entries
                    </span>
                
                    <!-- Pagination Buttons -->
                    <div>
                      <button
                        class="btn btn-secondary me-2 pre-class"
                        [disabled]="currentPage === 1 || filteredTransactions.length === 0"
                        (click)="changePage(currentPage - 1)"
                      >
                        Previous
                      </button>
                
                      <ng-container *ngFor="let page of getPages()">
                        <button [disabled]="currentPage === page"
                        [ngStyle]="{
                          'background': !isValidPage(page)  ? 'none' : '',
                          'pointer-events':!isValidPage(page)  ? 'none' : '',
                          'padding':!isValidPage(page)  ? '0' : ''
                        }" [ngClass]="(currentPage === page) ? 'led':''"
                          class="btn btn-secondary me-2"
                          [class.active]="page === currentPage"
                          (click)="changePage(page)"
                        >
                          {{ page }}
                        </button>
                      </ng-container>
                
                      <button
                        class="btn btn-secondary pre-class"
                        [disabled]="currentPage === totalPages || filteredTransactions.length === 0"
                        (click)="changePage(currentPage + 1)"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </nav>
                
              </div>              
                <div class="col-md-3" 
                style="border: 1px solid #ccc; padding-left: 15px; padding-top: 15px; margin-left: 30px; border-radius: 8px; padding-right: 15px;">
                <h5 class="text-center">Set Ringtone</h5>
                <form>
                  <div class="mb-3 mt-3">
                    <label for="currency" class="form-label">Select Currency</label>
                    <select
                      class="form-select"
                      id="currency"
                      name="currency"
                      [(ngModel)]="currency"
                      (change)="onCurrencyChange($event)"
                      style="padding: 8px;"
                    >
                      <option value="" disabled>Select Currency</option>
                      <option value="ZWG">ZWG</option>
                      <option value="USD">USD</option>
                    </select>
                  </div>

                    <div class="mb-3">
                        <label for="plan" class="form-label">Select Plan</label>
                        <select class="form-select" [(ngModel)]="plan" id="plan" name="plan" (change)="onPlanSelect($event)" style="padding: 8px;">
                          <option value="" disabled selected>Select Plan</option>
                          <option *ngFor="let plan of plans" [value]="plan.id">
                            {{ plan.planName }} - {{ plan.amount }} 
                            {{ selectedCurrencyId === 2 ? 'ZWG' : '$ USD' }}
                            <span *ngIf="plan.planName.toLowerCase() === 'daily'">/day</span>
                            <span *ngIf="plan.planName.toLowerCase() === 'weekly'">/week</span>
                            <span *ngIf="plan.planName.toLowerCase() === 'monthly'">/month</span>
                          </option>
                        </select>   
                    </div>
                    <div class="mb-3">
                        <label for="music-name" class="form-label">Music Name</label>
                        <input type="text" class="form-control" id="music-name" placeholder="Music Name" name="music-name" [value]="musicName" readonly />
                    </div>
                    <div class="mb-3">
                        <label for="msisdn" class="form-label">Customer Msisdn</label>
                        <input type="text" class="form-control" id="msisdn" name="msisdn" [value]="phone" readonly>
                    </div>
                    <!-- <div *ngIf="errorMessage" class="alert alert-danger">
                        {{ errorMessage }}
                      </div> -->
                    <div class="d-flex justify-content-between mb-3">
                        <button type="submit" class="btn custom-btn-change-password poupo" [disabled]="!currency || !plan || !musicName || !phone" style="margin-right:10px; cursor: pointer;" (click)="openAddForm(openAddRingtoneModal)">Add Ringtone</button>
                        <button type="button" class="btn btn-secondary custom-btn-cancel"  (click)="onCancel()">Cancel</button>
                    </div>
                </form>
            </div>
            </div>
        </div>

    </ng-container>

    <ng-template #addChangePasswordModal let-modal>
      <div class="modal-dialog">
        <div class="modal-content change-password-container">
          <div class="modal-header">
            <h5 class="modal-title">Change Password</h5>
            <button type="button" class="btn-close" (click)="onCancelchange()"></button>
          </div>
          <div class="modal-body" style="padding: 20px;margin-top: -20px;">
            <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
              <!-- Current Password -->
              <div class="form-group">
                <label for="oldPassword">Current Password <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input (keypress)="preventSpace($event)" maxlength="20" [type]="showOldPassword ? 'text' : 'password'"
                    id="oldPassword" autocomplete="new-password" class="form-control"
                    style="margin-top: -12px;margin-bottom: -5px;" formControlName="oldPassword"
                    placeholder="Enter Current Password" />
                  <i class="fa" [ngClass]="showOldPassword ? 'fa-eye-slash' : 'fa-eye'"
                    (click)="togglePasswordVisibility('old')"
                    style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                  </i>
                </div>
                <div *ngIf="oldPassword?.invalid && oldPassword?.touched" class="text-danger">
                  <div *ngIf="oldPassword?.errors?.['required']">Current Password is required</div>
                </div>
              </div>
  
              <!-- New Password -->
              <div class="form-group">
                <label for="newPassword">New Password <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input style="margin-top: -12px;margin-bottom: -5px;" (keypress)="preventSpace($event)" maxlength="20"
                    [type]="showNewPassword ? 'text' : 'password'" autocomplete="new-password" id="newPassword"
                    class="form-control" formControlName="newPassword" placeholder="Enter New Password" />
                  <i class="fa" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"
                    (click)="togglePasswordVisibility('new')"
                    style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                  </i>
                </div>
                <div *ngIf="newPassword?.invalid && newPassword?.touched" class="text-danger">
                  <div *ngIf="newPassword?.errors?.['required']">Password is required</div>
                  <div *ngIf="newPassword?.errors?.['pattern']">Password must be at least 8 characters long, contain at
                    least one number, one uppercase letter, and one lowercase letter</div>
                  <div *ngIf="newPassword?.errors?.['sameAsOldPassword']">New Password must be different from Current
                    Password</div>
                </div>
              </div>
  
              <!-- Confirm Password -->
              <div class="form-group" style="margin-bottom: 40px;">
                <label for="confirmPassword">Confirm Password<span style="color: red;margin-left: 5px;">*</span></label>
                <div class="input-group" style="position: relative;">
                  <input style="margin-top: -12px;margin-bottom: -10px;" (keypress)="preventSpace($event)" maxlength="20"
                    autocomplete="new-password" [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword"
                    class="form-control" formControlName="confirmPassword" placeholder="Confirm New Password" />
                  <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"
                    (click)="togglePasswordVisibility('confirm')"
                    style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                  </i>
                </div>
                <div *ngIf="confirmPassword?.invalid && confirmPassword?.touched" class="text-danger">
                  <div *ngIf="confirmPassword?.errors?.['required']">Confirm Password is required</div>
                  <div *ngIf="confirmPassword?.errors?.['mustMatch']">Passwords do not match</div>
                </div>
              </div>
  
              <!-- <div *ngIf="passwordErrorMessage" class="text-danger">
                {{ passwordErrorMessage }}
              </div>
              <div *ngIf="successMessage" class="success-message">
                {{ successMessage }}
              </div> -->
              <div class="modal-footer" style="margin-top: 20px;padding: 0 !important;">
                <button type="button" class="btn custom-btn-change-password" style="margin-right:10px"
                  (click)="onSubmit()">
                  Change Password
                </button>
                <button type="button" class="btn btn-secondary custom-btn-cancel" (click)="modal.dismiss('Cancel click')">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
  
    </ng-template>

  <ng-template #openAddRingtoneModal let-modal>
    <div class="modal-dialog">
      <div class="modal-content change-password-container">
        <div class="modal-header">
          <h5 class="modal-title">Confirmation</h5>
          <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body modal-body-custom">
          <p class="modal-text">
            Are you sure you want to add this ringtone?
          </p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-success custom-btn-logout" (click)="AddSong()">
            Confirm
          </button>
          <button class="btn btn-secondary custom-btn-cancel" (click)="modal.dismiss('Cross click')">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </ng-template>



  <ng-template #openLogOutModel let-modal>
    <div class="modal-dialog">
      <div class="modal-content change-password-container">
        <div class="modal-header">
          <h5 class="modal-title">Confirm {{statusChangeText}}</h5>
          <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body" style="padding: 20px;height: 15vh;width:100vw; word-break:break-all;">
          <p style="margin-top: 15px; margin-left:5px">Are you sure you want to logout ?</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-success custom-btn-logout" (click)="logout()">
            Logout
          </button>
          <button class="btn btn-secondary custom-btn-cancel" (click)="modal.dismiss('Cross click')">Cancel
          </button>
        </div>
      </div>
    </div>
  </ng-template>

</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">Please Wait. </p>
</ngx-spinner>